import React, { useRef, useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import styles from './ScrollBar.module.scss';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_TIMELINE_STORE, numberOfThumbnailsToView } from 'store';
import { ScrollBarProps } from './types';

const ScrollBar = (props: ScrollBarProps) => {
  const {
    [EDITOR_TIMELINE_STORE]: {
      thumbnailsViewablePercentage,
      skipThumbnails,
      timeLineThumbnailsNumber,
      setSkipThumbnails,
      onScrollBarDragStop
    }
  } = props;

  const containerRef = useRef(null);
  const draggablePinRef = useRef(null);
  const [pixelsPerThumbnail, setPixelsPerThumbnail] = useState(1);

  useEffect(() => {
    const { clientWidth: containerWidth } = containerRef.current;
    if (timeLineThumbnailsNumber === 0) return;
    setPixelsPerThumbnail(containerWidth / timeLineThumbnailsNumber);
  }, [timeLineThumbnailsNumber]);

  const handleDrag = (_, { x, lastX }) => {
    if (x % pixelsPerThumbnail < 1 && lastX !== x) {
      setSkipThumbnails(Math.ceil(x / pixelsPerThumbnail));
    }
  };

  const getPosition = () => {
    if (
      !containerRef ||
      !containerRef.current ||
      !draggablePinRef ||
      !draggablePinRef.current
    ) return null;

    const { clientWidth } = draggablePinRef.current;
    const calculatedX = skipThumbnails * pixelsPerThumbnail;
    const { clientWidth: containerWidth } = containerRef.current;
    const maxX = containerWidth - clientWidth;
    const x = calculatedX > maxX ? maxX : calculatedX;
    const position = { x, y: 0 };
    return position;
  };

  return (
    <div className={styles.container} ref={containerRef}>
      <Draggable
        axis='x'
        handle='.handle'
        defaultPosition={{ x: 0, y: 0 }}
        position={getPosition()}
        onDrag={handleDrag}
        onStop={onScrollBarDragStop}
        bounds='parent'
      >
        <div
          ref={draggablePinRef}
          className={`handle ${styles.draggablePin}`}
          style={{
            width: `${pixelsPerThumbnail * numberOfThumbnailsToView}px`,
            display: thumbnailsViewablePercentage >= 100 ? 'none' : ''
          }}
        />
      </Draggable>

    </div>
  );
};

export default inject(EDITOR_TIMELINE_STORE)(observer(ScrollBar));
